
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/usage_rights_modal';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('usage_rights_modal');
  